var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "course-page",
        {
          "shopping-version": _vm.showShoppingVersion,
          mobile: _vm.isMobile(_vm.$mq)
        }
      ]
    },
    [
      _vm.showLoggedoutCouponBanner ? _c("LoggedOutCouponBanner") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns-container" }, [
        _c(
          "div",
          { staticClass: "cover-column" },
          [
            _c("Cover", {
              attrs: {
                course: _vm.course,
                "has-practice": _vm.hasPractice,
                "is-in-progress-view": !_vm.showShoppingVersion
              },
              on: {
                "view-more": function($event) {
                  _vm.isCourseModalOpen = true
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chapters-and-description-column" },
          [
            _c("ChaptersList", {
              attrs: {
                chapters: _vm.chapters,
                "course-id": _vm.course.course_id,
                "recommended-slug": _vm.course.recommended_lesson_slug,
                "course-version-name": _vm.course.version_name,
                "disable-auto-scroll": _vm.shouldHighlightFirstLesson,
                "previous-lesson-slug":
                  _vm.previousLessonSlug || _vm.computedPreviousLessonSlug,
                "enable-just-completed-animation":
                  _vm.enableJustCompletedAnimation
              }
            }),
            _vm._v(" "),
            !_vm.isAuthenticated
              ? _c("DetailedDescription", { attrs: { course: _vm.course } })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isOnboardingOverlayOpen && _vm.chapters[0]
        ? _c("OnboardingOverlay", {
            attrs: { "first-chapter-name": _vm.chapters[0].name },
            on: {
              "overlay-closed": function($event) {
                _vm.isOnboardingOverlayOpen = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile(_vm.$mq) && _vm.isCourseModalOpen
        ? _c("CourseModal", {
            attrs: { course: _vm.course },
            on: {
              "modal-closed": function($event) {
                _vm.isCourseModalOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }